// hooks/useClubsAndLeagues.js
import { useQuery } from "@tanstack/react-query";
import { afGetClubs } from "../services/apiFootballService/endPoints/clubs";
import { afGetLeagues } from "../services/apiFootballService/endPoints/leagues";

const fetchAllClubsAndLeagues = async (country, season, leagueId) => {
  try {
    const [leagues, clubs] = await Promise.all([
      afGetLeagues(country, season),
      afGetClubs(leagueId, season),
    ]);

    return {
      allLeagues: leagues,
      allClubs: clubs,
    };
  } catch (error) {
    console.error("Error fetching clubs and leagues:", error);
    throw error;
  }
};

export const useClubsAndLeagues = (country, season, leagueId) => {
  return useQuery({
    queryKey: ["clubsAndLeagues", country, season, leagueId],
    queryFn: () => fetchAllClubsAndLeagues(country, season, leagueId),
    staleTime: 1000 * 60 * 60, // 1 hour
    enabled: !!(country && season && leagueId),
  });
};
